<template>
  <div>
    <div class="title" @click="toggleContent">
      <h3>{{ title }}</h3>
      <template v-if="isFolding">
        <inline-svg :src="arrowDropImage" />
      </template>
    </div>
    <div class="content" :class="{ foldable: isFolding }">
      <slot name="containerContent"></slot>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import InlineSvg from "vue-inline-svg";
export default {
  name: "BaseContainer",
  components: {
    InlineSvg,
  },
  props: {
    title: {
      type: String,
    },
    isFolding: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isClosed = ref(true);

    const arrowDropImage = computed(() =>
      isClosed.value
        ? require("@/assets/img/icon/arrow_drop_down.svg")
        : require("@/assets/img/icon/arrow_drop_up.svg")
    );

    const toggleContent = () => {
      if (!props.isFolding) {
        return;
      }
      isClosed.value = !isClosed.value;
      const content = document.querySelector(".content.foldable");
      if (isClosed.value) {
        content.style.maxHeight = 0;
        return;
      }
      content.style.maxHeight = content.scrollHeight + "px";
    };

    return { isClosed, arrowDropImage, toggleContent };
  },
};
</script>
